import {EventLogSearchParamsDto, eventLogSearchParamsDtoToParams} from "./dtos/EventLogSearchParamsDto";
import {invoicingAgent} from "../../app/api/agent";
import {PaginationResultDto} from "../../app/dtos/PaginationResultDto";
import {EventLogListDto} from "./dtos/EventLogListDto";

export const getEventLogListRequest = (searchParams: EventLogSearchParamsDto) =>
  invoicingAgent.getRequest<PaginationResultDto<EventLogListDto>>(
    `api/auditlog?${eventLogSearchParamsDtoToParams(searchParams)}`
  );
